var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKulpaIChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 20,
    viewBox: "0 0 58 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1.356,
    x2: 1.675,
    y2: -0.677,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#452cfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23167e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kulpa_I_chip",
    "data-name": "Kulpa I chip",
    transform: "translate(6208 -5338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3935",
    "data-name": "Rect\\xE1ngulo 3935",
    width: 58,
    height: 20,
    rx: 4,
    transform: "translate(-6208 5338)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9681",
    "data-name": "Trazado 9681",
    d: "M6.611,0H7.9L4.4-4.235,7.689-7.7H6.435L2.255-3.4V-7.7h-1.1V0h1.1V-1.991l1.408-1.43ZM13.09-5.83v3.014a1.716,1.716,0,0,1-1.8,1.936c-1,0-1.573-.572-1.573-1.716V-5.83H8.657v3.355A2.291,2.291,0,0,0,11.165.066a2.372,2.372,0,0,0,1.98-.946V0h1V-5.83ZM16.159,0h1.056V-8.162H16.159Zm6.16-5.885a2.483,2.483,0,0,0-2.079.979V-5.83H19.228V2.134h1.056V-.88a2.49,2.49,0,0,0,2.035.946,2.833,2.833,0,0,0,2.948-2.981A2.83,2.83,0,0,0,22.319-5.885ZM22.231-.858a1.928,1.928,0,0,1-1.958-2.057,1.925,1.925,0,0,1,1.958-2.046A1.927,1.927,0,0,1,24.2-2.915,1.93,1.93,0,0,1,22.231-.858ZM28.8-5.885a3.882,3.882,0,0,0-2.409.748l.44.792a2.948,2.948,0,0,1,1.848-.627c1.045,0,1.562.517,1.562,1.408v.209H28.567c-1.738,0-2.343.77-2.343,1.7,0,1.012.836,1.716,2.156,1.716A2.164,2.164,0,0,0,30.294-.77V0h1V-3.52C31.3-5.115,30.393-5.885,28.8-5.885ZM28.556-.748c-.8,0-1.287-.363-1.287-.946,0-.5.3-.9,1.342-.9h1.628v.814A1.691,1.691,0,0,1,28.556-.748Zm9.075-6.2a.731.731,0,0,0,.77-.759.643.643,0,0,0-.671-.616.729.729,0,0,0-.759.737A.637.637,0,0,0,37.631-6.952ZM35.64,0H36.7l1.155-5.83H36.795Z",
    transform: "translate(-6198.063 5352)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulpaIChip);
export default __webpack_public_path__ + "static/media/kulpa-i-chip.e3ef284080d56581cb34bdf0492b932f.svg";
export { ForwardRef as ReactComponent };